export class PrincipalConfig {
    public static readonly PersonFilterKey: string = 'person';
    public static readonly RosterViewStateKey: string = 'view-state';
    public static readonly ScrollPositionKey: string = 'scrollPosition';
    public static readonly ShowQuartersKey: string = 'show';
    public static readonly ShowSummaryKey: string = 'showSummary';
    public static readonly ShowRestTimeKey: string = 'showRest';
    public static readonly ShowDailyDutyFiguresKey: string = 'showDutyFigures';
    public static readonly ShowDeltaKey: string = 'showDelta';
    public static readonly ShowRosterFilters: string = 'showRosterFilters';
    public static readonly ReportFiltersKey: string = 'reportFilters';
    public static readonly ReportGridConfigKey: string = 'reportGridConfig';
    public static readonly ReportGridStateKey: string = 'reportGridState';
    public static readonly VacationToolKey: string = 'vacationToolState';
    public static readonly ChangeLogFiltersKey: string = 'changeLogFilters';
    public static readonly ChangeLogConfigKey: string = 'changeLogGridConfig';
    public static readonly UseKeyboardShortcutsKey: string = 'useKeyboardShortcuts';
    public static readonly ShowHistorizedRosterline: string = 'showHistorizedRosterline';
    public static readonly ShowSwissTime: string = 'showSwissTime';
    public static readonly ShowSwissTimeGround: string = 'showSwissTimeGround';
    public static readonly ShowActivePersons: string = 'showActivePersons';
    public static readonly Zoom: string = 'zoom';
    public static readonly ViewGroup: string = 'View';
    public static readonly DarkMode: string = 'DarkMode';
    public static readonly FdrGroundView: string = 'FdrGroundView';
    public static readonly SectorsSortOrder: string = 'SectorsSortOrder';

    public static readonly PersonFilterGroup: string = 'filter';
    public static readonly PersonOrderGroup: string = 'personOrder';
    public static readonly MainRosterGroup: string = 'main-roster';
    public static readonly CommonGroup: string = 'common';
    public static readonly ChangeLogGroup: string = 'changeLog';
    public static readonly FlightsGantGroup: string = 'flightsGantGroup';

    public static readonly PersonReportGroup: string = 'personReport';
    public static readonly SimulationReportGroup: string = 'simReport';
    public static readonly RosterImportsGroup: string = 'rosterImportsGroup';
    public static readonly AeroPersExportsGroup: string = 'aeroPersExportsGroup';
    public static readonly EfaExportsGroup: string = 'aeroPersExportsGroup';
    public static readonly RosterImportDetailsGroup: string = 'rosterImportDetailsGroup';
    public static readonly RecurrentTrainingReportGroup: string = 'recurrentTrainingReport';
    public static readonly SimulatorLicenseStatusReportGroup: string = 'simulatorLicenseStatusReport';
    public static readonly StandbyReportGroup: string = 'standbyReport';
    public static readonly VacationRequestReportGroup: string = 'vacationRequestReport';
    public static readonly TrainingsReportGroup: string = 'trainingsReport';
    public static readonly AirportRecencyReportGroup: string = 'airportRecencyReport';
    public static readonly AreaRouteCompetenceReportGroup: string = 'areaRouteCompetencyReport';
    public static readonly SectorsReportGroup: string = 'sectorsReport';
    public static readonly CrewDutyReportGroup: string = 'crewDutyReport';
    public static readonly HomeStudyReportGroup: string = 'homeStudyReport';
    public static readonly HomeStudyPersonGroup: string = 'homeStudyPersonReport';
    public static readonly CommentsReportGroup: string = 'commentsReport';
    public static readonly OffDaysReportGroup: string = 'offDaysReport';
    public static readonly AbsenceReportGroup: string = 'absenceReport';
    public static readonly RosterReportGroup: string = 'rosterReport';
    public static readonly VacationBalanceCorrectionGroup: string = 'vacationBalanceCorrection';
    public static readonly VacationToolGroup: string = 'vacationToolGroup';
    public static readonly HotelPreReservationLocationGroup: string = 'hotelPreReservationLocationGroup';
    public static readonly HotelPreReservationBookingGroup: string = 'hotelPreReservationBookingGroup';
    public static readonly HotelManagementDailyGroup: string = 'hotelManagementDailyGroup';
    public static readonly HotelManagementDailyDetailsGroup: string = 'hotelManagementDailyDetailsGroup';
    public static readonly AircraftTypeRecencyCockpitReportGroup: string = 'aircraftTypeRecencyCockpitReport';
    public static readonly AircraftTypeRecencyCabinReportGroup: string = 'aircraftTypeRecencyCabinReport';
    public static readonly DooxReportGroup: string = 'dooxReport';
    public static readonly SeniorityReportGroup: string = 'seniorityReport';
    public static readonly GroundStatisticsReportGroup: string = 'groundStatistics';
    public static readonly ExperienceReportGroup: string = 'experienceReportGroup';
    public static readonly VacationDetailsAbsenceGroup: string = 'VacationDetailsAbsence';
    public static readonly VacationDetailsRequestDaysGroup: string = 'VacationDetailsRequestDays';
    public static readonly ErrorReportGroup: string = 'errorReport';
    public static readonly XStarMonitoringReportGroup: string = 'xStarMonitoringReport';
    public static readonly DosimetryReportGroup: string = 'dosimetryReport';
    public static readonly CrewApiConfigReportGroup: string = 'crewapiconfig';
    public static readonly GenDecConfigReportGroup: string = 'gendecconfig';
    public static readonly CrewNotificationTimeReportGroup: string = 'crewNotificationTimeReport';

    public static readonly RotationToolGroup: string = 'rotationTool';
    public static readonly VacManagementGroup: string = 'vacationManagementGroup';
    public static readonly VacManagementCockpitGroup: string = 'vacationManagementCockpitGroup';
    public static readonly VacManagementCabinGroup: string = 'vacationManagementCabinGroup';
    public static readonly VacManagementGroundGroup: string = 'vacationManagementGroundGroup';
    public static readonly PersonVacYearDetailsReportGroup: string = 'personVacYearDetailsReportGroup';
    public static readonly TzvYearOverviewReportGroup: string = 'tzvYearOverviewReportGroup';

    public static readonly LicenseManagementGroup: string = 'licenseManagementGroup';
    public static readonly CourseManagementGroup: string = 'courseManagementGroup';
    public static readonly CabinCrewAttestationGroup: string = 'cabinCrewAttestationGroup';
    public static readonly FdrGroup: string = 'flightDutyRecordGroup';
    public static readonly GenDecGroup: string = 'flightDutyRecordGroup';

    public static readonly ReserveManagementGroup: string = 'reserveManagementGroup';
    public static readonly ReserveManagementCockpitGroup: string = 'vacationManagementCockpitGroup';
    public static readonly ReserveManagementCabinGroup: string = 'vacationManagementCabinGroup';
}